import moment from "moment";
import { TableRowProps } from "../../molecules/TableRow/TableRowAtom";
import {
  createCellWithChildren,
  createInfoCell,
} from "../../utilities/CreateCell";
import { createRow } from "../../utilities/CreateRow";
import { formatLocalDate } from "../../utilities/DataMatrixParser/formatTime";

export interface NotificationData {
  id: string;
  returnRequestTargetId: string;
  pharmacyTargetId: string;
  userTargetId: string;
  notificationDate: string;
  notificationType: string;
  triggeringUserId: {
    username: string;
  };
  creatorUserId: {
    username: string;
  };
}

export const createNotificationsRows = (
  data: Array<NotificationData>
) => {
  const rows: Array<TableRowProps> = [];
  data.forEach((entry: NotificationData) => {
    const row: TableRowProps = createRow(
      createNumberCell(entry),
      createCreatedAtCell(entry),
      createNotificationTypeCell(entry),
      createUserCell(entry),
      createCreatorCell(entry)
    );
    rows.push(row);
  });
  return rows;
};

const capitalize = (str: string): string => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
}

const createNumberCell = (entry: NotificationData) => {
  return createInfoCell(entry.id);
};

const createCreatedAtCell = (entry: NotificationData) => {
  return createInfoCell(formatLocalDate(entry.notificationDate));
};

const createNotificationTypeCell = (entry: NotificationData) => {
 const returnRequestID = entry.returnRequestTargetId;
  const pharmacyID = entry.pharmacyTargetId;
  const userID = entry.userTargetId;

  let path = "";
  const hasRequestIds = returnRequestID || pharmacyID;
  
  switch (entry.notificationType) {
    case "New Return Request Created":
      if (hasRequestIds) {
        path = `/admin/pharmacies/${pharmacyID}/returnrequests/${returnRequestID}/items`;
      }
      break;
    case "Note Update":
       if (hasRequestIds) {
        path = `/admin/pharmacies/${pharmacyID}/returnrequests/${returnRequestID}/items?openNote=true`;
      }
      break;
    case "New Pharmacy Created":
      if (hasRequestIds) {
        path = `/admin/pharmacies/${pharmacyID}`;
      }
      break;
    case "New User Created":
      if (hasRequestIds) {
       path = `/admin/${userID}/pharmacy/management`;
      }
      break;
    default:
      return createInfoCell(capitalize(entry.triggeringUserId.username));
  }

  if (!path) {
      return createInfoCell(entry.notificationType);
  }

  return createCellWithChildren(
    
  <a href={path} style={{ color: "#007bff", textDecoration: "underline" }}>
    {entry.notificationType}
  </a>
);
};

const createUserCell = (entry: NotificationData) => {
   return createInfoCell(capitalize(entry.triggeringUserId.username));
  };

  const createCreatorCell = (entry: NotificationData) => {
    const username = entry.creatorUserId?.username;
    return createInfoCell(username ? capitalize(username) : '-');
  };